import React from 'react'

import WhatsAppImgSrc from './whatsapp.svg'

interface ImageProps {
  width: number
  height: number
}

const WhatsAppIcon = ({ height, width }: ImageProps) => {
  return (
    <img
      src={WhatsAppImgSrc}
      className="activate-chatbot-btn"
      alt="whatsapp"
      width={width}
      height={height}
    />
  )
}

export default WhatsAppIcon
